import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import StartGameFlowLayout from "../components/StartGameFlowLayout";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import reglas1 from "../assets/avatares/reglas-1.mp4";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME3, {
					state: { activeScenario: 1 },
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<StartGameFlowLayout
			brandTheme
			sidebarTitle="Reglas Dinámica I"
			loading={loading}
			onContinue={handleNext}
			video={reglas1}
		>
			<div className="start-game-rule-block">
				<h3>Trabajo en equipo</h3>
				<p>
					Formaréis parte de uno de los equipos participantes. Cada equipo contará con una tablet para avanzar por la dinámica, analizar la situación planteada y consensuar sus decisiones.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Toma de decisiones</h3>
				<p>
					Para avanzar, el equipo deberá responder a diferentes preguntas y pruebas relacionadas con la intervención. Algunas respuestas serán más adecuadas que otras, por lo que cada decisión tendrá una puntuación diferente.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Puntuación del equipo</h3>
				<p>
					Durante la dinámica, cada equipo irá acumulando puntos según la calidad de sus decisiones. La puntuación final reflejará vuestra capacidad para analizar la situación, priorizar actuaciones y aplicar criterios profesionales.
				</p>
			</div>
		</StartGameFlowLayout>
	);
}
